module.exports = __webpack_public_path__ + "assets/img/4.d8816298.jpg";